import { render, staticRenderFns } from "./KidsOrderComponent.vue?vue&type=template&id=5a8e5eee&"
import script from "./KidsOrderComponent.vue?vue&type=script&lang=js&"
export * from "./KidsOrderComponent.vue?vue&type=script&lang=js&"
import style0 from "./KidsOrderComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports